const PointsManage = () => import('@/vuepage/marketing-manage/PointsManage');
const PointsIssuanceList = () => import('@/vuepage/marketing-manage/PointsIssuanceList');
const FeedbackList = () => import('@/vuepage/marketing-manage/FeedbackList');
const FeedbackListDetail = () => import('@/vuepage/marketing-manage/components/FeedbackListDetail');
const MessageList = () => import('@/vuepage/marketing-manage/MessageList');

export default [{
		path: '/points-manage',
		component: PointsManage,
		meta: [{
				name: '营销管理'
			},
			{
				name: '积分管理',
				activeRoute: '/points-manage'
			}
		]
	},
	{
		path: '/points-issuance-list',
		component: PointsIssuanceList,
		meta: [{
				name: '营销管理'
			},
			{
				name: '积分下发',
				activeRoute: '/points-issuance-list'
			}
		]
	},
	{
		path: '/feedback-list',
		component: FeedbackList,
		meta: [{
				name: '营销管理'
			},
			{
				name: '问题反馈',
				activeRoute: '/feedback-list'
			}
		]
	},
	{
		path: '/feedback-list-detail',
		component: FeedbackListDetail,
		meta: [{
				name: '营销管理'
			},
			{
				name: '问题反馈',
				activeRoute: '/feedback-list'
			},
			{
				name: '问题反馈详情',
				activeRoute: '/feedback-list-detail'
			}
		]
	},
	{
		path: '/message-list',
		component: MessageList,
		meta: [{
				name: '营销管理'
			},
			{
				name: '消息推送',
				activeRoute: '/message-list'
			},
		]
	},

];